
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import { Group, User } from '@/types';

@Component
export default class UserGroups extends Vue {
  @Prop(Object) readonly value!: User;
  @Prop({ type: Boolean, default: false }) readonly useShowInLeadUsers!: boolean;

  get user() {
    return this.value;
  }

  get userGroups(): Group[] {
    return this.value && Array.isArray(this.value.groups) && this.value.groups.length > 0
      ? this.value.groups.filter((element) => {
        if (!this.useShowInLeadUsers) return true;
        return element.showInLeadUsers ?? false;
      })
      : [];
  }

  isOutlined(g: Group) {
    // eslint-disable-next-line no-console
    console.log('Group ', g.name);
    return g.isActive;
  }

  textColor(g: Group) {
    return g.isActive
      ? 'black'
      : 'white';
  }
}
